export const COMPS_ROOT_NAMESPACE = 'comps-root'
export const SVG_STORE_NAMESPACE = 'svgStore'

export const PARSED_SVG_ASPECT = 'parsedSvg'
